"use client";

import styled from "styled-components";

interface ThemeProps {
  $float: boolean;
}

interface BoxTabSwitchProps {
  $active: string;
}
export const SwiperButton = styled.button<ThemeProps>`
  padding: 4px 5px;
  border-radius: 100px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #acbacd;
  max-height: 34px;
  background-color: transparent;
  position: relative;
  z-index: 0;
  cursor: pointer;
  &:hover {
    background-color: transparent;
  }

  ${({ $float }) =>
    $float ? "position: absolute; top: 20px; right: 20px;" : ""}
`;

export const BoxTabSwitch = styled.span<BoxTabSwitchProps>`
  position: absolute;
  top: 2px;
  width: 21px;
  height: 21px;
  border-radius: 9999px;
  z-index: -1;
  transition:
    transform 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  transform: ${({ $active }) =>
    $active === "true" ? "translateX(-3px)" : "translateX(22px)"};
  background-color: ${({ $active }) =>
    $active === "true" ? "#acbacd" : "transparent"};
  border: 1px solid #acbacd;
`;

export const IconButton = styled.svg<BoxTabSwitchProps>`
  margin-top: 0;
  font-size: 14px;
  transition: all 0.3s ease-in-out;
  fill: transparent;
  width: 15px;
  ${({ $active }) => $active === "true" && `fill: white;`}
`;
